module.exports = __webpack_public_path__ + "media/beep-06.89820ccd.wav";